import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { useAppContext } from '../context/AppContext';

export const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  
  // Use optional chaining to handle cases where context might not be available
  const { city } = useAppContext() || {};

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
    }`}>
      <div className="container px-4 mx-auto">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src={isScrolled ? "/img/logo.png" : "/img/logo-bianco.png"} 
              alt="Vendi la Tua Auto" 
              className="h-8"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="items-center hidden space-x-8 md:flex">
            <a 
              href="/" 
              className={`font-medium transition-colors ${
                isScrolled ? 'text-gray-800 hover:text-blue-600' : 'text-white hover:text-blue-300'
              }`}
            >
              Home
            </a>
            <a 
              href="/#come-funziona" 
              className={`font-medium transition-colors ${
                isScrolled ? 'text-gray-800 hover:text-blue-600' : 'text-white hover:text-blue-300'
              }`}
            >
              Come Funziona
            </a>
            <a 
              href="/#servizi" 
              className={`font-medium transition-colors ${
                isScrolled ? 'text-gray-800 hover:text-blue-600' : 'text-white hover:text-blue-300'
              }`}
            >
              Servizi
            </a>
            <a 
              href="/#marche-e-veicoli" 
              className={`font-medium transition-colors ${
                isScrolled ? 'text-gray-800 hover:text-blue-600' : 'text-white hover:text-blue-300'
              }`}
            >
              Marche e Veicoli
            </a>
            <a 
              href="/#faq" 
              className={`font-medium transition-colors ${
                isScrolled ? 'text-gray-800 hover:text-blue-600' : 'text-white hover:text-blue-300'
              }`}
            >
              FAQ
            </a>
          </nav>

          {/* CTA Button */}
          <div className="items-center hidden space-x-4 md:flex">
            <a 
              href="tel:+61451326175" 
              className={`flex items-center px-4 py-2 font-medium transition-all duration-300 rounded-lg ${
                isScrolled 
                  ? 'bg-blue-600 text-white hover:bg-blue-700' 
                  : 'bg-white text-blue-600 hover:bg-gray-100'
              }`}
            >
              <Phone className="w-4 h-4 mr-2" />
              +379 1281345
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={toggleMenu}
            className={`md:hidden p-2 rounded-lg ${
              isScrolled ? 'text-gray-800' : 'text-white'
            }`}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="bg-white shadow-lg md:hidden">
          <div className="container px-4 py-4 mx-auto">
            <nav className="flex flex-col space-y-4">
              <a 
                href="/" 
                className="font-medium text-gray-800 hover:text-blue-600"
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </a>
              <a 
                href="/#come-funziona" 
                className="font-medium text-gray-800 hover:text-blue-600"
                onClick={() => setIsMenuOpen(false)}
              >
                Come Funziona
              </a>
              <a 
                href="/#servizi" 
                className="font-medium text-gray-800 hover:text-blue-600"
                onClick={() => setIsMenuOpen(false)}
              >
                Servizi
              </a>
              <a 
                href="/#marche-e-veicoli" 
                className="font-medium text-gray-800 hover:text-blue-600"
                onClick={() => setIsMenuOpen(false)}
              >
                Marche e Veicoli
              </a>
              <a 
                href="/#faq" 
                className="font-medium text-gray-800 hover:text-blue-600"
                onClick={() => setIsMenuOpen(false)}
              >
                FAQ
              </a>
              <a 
                href="tel:+61451326175" 
                className="flex items-center px-4 py-2 font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700"
                onClick={() => setIsMenuOpen(false)}
              >
                <Phone className="w-4 h-4 mr-2" />
                +379 1281345
              </a>
            </nav>
          </div>
        </div>
      )}
    </header>
  );
};